// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-code-editor {
  height: 500px;
}

.comparediff .editor-container {
  border: 1px solid #bcbcbc;
}

.hide-version-overflow {
  overflow-x: hidden;
  overflow-y: hidden;
  display: flex;
}

::ng-deep.comparediff .editor-container {
  border: 1px solid #bcbcbc;
}

.modal-header {
  border-bottom: 1px solid #dee2e6;
  position: relative;
}

.modal-footer {
  border-top: 1px solid #dee2e6;
  justify-content: space-between;
  align-items: center;
}

::ng-deep.compare-pinned-modal .modal-dialog {
  max-width: 98% !important;
  width: 98% !important;
  margin-top: 0px !important;
}

::ng-deep .matoutlinestyles .mat-form-field-wrapper {
  padding-bottom: 0 !important;
}

::ng-deep .matoutlinestyles .mat-form-field-infix {
  padding: 0.5em 0 !important;
  border-top: 0 !important;
}

::ng-deep .matoutlinestyles .mat-form-field-label-wrapper {
  top: -0.84375em !important;
}

.active_card {
  border-left: 4px solid #07a36e;
}

.progress_card {
  border-left: 4px solid #ffc107;
}

.failed_card {
  border-left: 4px solid #da606c;
}

.primary_card {
  border-left: 4px solid #007bff;
}

.ignored_card {
  border-left: 4px solid rgba(128, 128, 128, 0.6901960784);
}

.inprogress_card {
  border-left: 4px solid #ff8900;
}

.border-gradient {
  border-left: 4px solid !important;
  border-image-slice: 1;
  border-block: 0;
  border-right: 0;
}

.border-gradient-redgreen {
  border-image-source: linear-gradient(to bottom, #db6c6c, #22ed86);
}

::ng-deep .compare-pinned-component .radio-button-group {
  cursor: pointer !important;
}
::ng-deep .compare-pinned-component .radio-button-group mat-radio-button {
  cursor: pointer !important;
  pointer-events: auto !important;
}
::ng-deep .compare-pinned-component .radio-button-group mat-radio-button * {
  cursor: pointer !important;
  pointer-events: auto !important;
}
::ng-deep .compare-pinned-component .radio-button-group mat-radio-button .mdc-form-field {
  cursor: pointer !important;
  pointer-events: auto !important;
}
::ng-deep .compare-pinned-component .radio-button-group mat-radio-button .mdc-form-field * {
  cursor: pointer !important;
  pointer-events: auto !important;
}
::ng-deep .compare-pinned-component .radio-button-group mat-radio-button .mdc-form-field .mdc-form-field__label {
  cursor: pointer !important;
  pointer-events: auto !important;
}
::ng-deep .compare-pinned-component .radio-button-group mat-radio-button .mdc-form-field .mdc-radio {
  cursor: pointer !important;
  pointer-events: auto !important;
  bottom: 3px;
}
::ng-deep .compare-pinned-component .radio-button-group mat-radio-button .mdc-form-field .mdc-radio * {
  cursor: pointer !important;
  pointer-events: auto !important;
}
::ng-deep .compare-pinned-component .radio-button-group mat-radio-button .mdc-form-field .mdc-radio .mdc-radio__native-control {
  cursor: pointer !important;
  pointer-events: auto !important;
}
::ng-deep .compare-pinned-component .radio-button-group mat-radio-button label {
  cursor: pointer !important;
  pointer-events: auto !important;
}
::ng-deep .compare-pinned-component .radio-button-group mat-radio-button .mat-mdc-radio-button {
  cursor: pointer !important;
  pointer-events: auto !important;
}
::ng-deep .compare-pinned-component .radio-button-group mat-radio-button input[type=radio] {
  cursor: pointer !important;
}
::ng-deep .compare-pinned-component mat-radio-group.radio-button-group mat-radio-button,
::ng-deep .compare-pinned-component mat-radio-group.radio-button-group mat-radio-button * {
  cursor: pointer !important;
}`, "",{"version":3,"sources":["webpack://./src/app/compare-pinned/compare-pinned.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAGE;EACE,yBAAA;AAAJ;;AAIA;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;AADF;;AAKE;EACE,yBAAA;AAFJ;;AAMA;EACE,gCAAA;EACA,kBAAA;AAHF;;AAMA;EACE,6BAAA;EACA,8BAAA;EACA,mBAAA;AAHF;;AAMA;EACE,yBAAA;EACA,qBAAA;EACA,0BAAA;AAHF;;AAMA;EACE,4BAAA;AAHF;;AAMA;EACE,2BAAA;EACA,wBAAA;AAHF;;AAMA;EACE,0BAAA;AAHF;;AAOA;EACE,8BAAA;AAJF;;AAMA;EACE,8BAAA;AAHF;;AAKA;EACE,8BAAA;AAFF;;AAIA;EACE,8BAAA;AADF;;AAGA;EACE,wDAAA;AAAF;;AAEA;EACE,8BAAA;AACF;;AACA;EACE,iCAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;AAEF;;AAAA;EACE,iEAAA;AAGF;;AAEE;EACE,0BAAA;AACJ;AACI;EACE,0BAAA;EACA,+BAAA;AACN;AACM;EACE,0BAAA;EACA,+BAAA;AACR;AAEM;EACE,0BAAA;EACA,+BAAA;AAAR;AAEQ;EACE,0BAAA;EACA,+BAAA;AAAV;AAGQ;EACE,0BAAA;EACA,+BAAA;AADV;AAIQ;EACE,0BAAA;EACA,+BAAA;EACA,WAAA;AAFV;AAIU;EACE,0BAAA;EACA,+BAAA;AAFZ;AAKU;EACE,0BAAA;EACA,+BAAA;AAHZ;AAQM;EACE,0BAAA;EACA,+BAAA;AANR;AASM;EACE,0BAAA;EACA,+BAAA;AAPR;AAUM;EACE,0BAAA;AARR;AAcE;;EAEE,0BAAA;AAZJ","sourcesContent":[".my-code-editor {\r\n  height: 500px;\r\n}\r\n\r\n.comparediff {\r\n  .editor-container {\r\n    border: 1px solid #bcbcbc;\r\n  }\r\n}\r\n\r\n.hide-version-overflow {\r\n  overflow-x: hidden;\r\n  overflow-y: hidden;\r\n  display: flex;\r\n}\r\n\r\n::ng-deep.comparediff {\r\n  .editor-container {\r\n    border: 1px solid #bcbcbc;\r\n  }\r\n}\r\n\r\n.modal-header {\r\n  border-bottom: 1px solid #dee2e6;\r\n  position: relative;\r\n}\r\n\r\n.modal-footer {\r\n  border-top: 1px solid #dee2e6;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n::ng-deep.compare-pinned-modal .modal-dialog {\r\n  max-width: 98% !important;\r\n  width: 98% !important;\r\n  margin-top: 0px !important;\r\n}\r\n\r\n::ng-deep .matoutlinestyles .mat-form-field-wrapper {\r\n  padding-bottom: 0 !important;\r\n}\r\n\r\n::ng-deep .matoutlinestyles .mat-form-field-infix {\r\n  padding: 0.5em 0 !important;\r\n  border-top: 0 !important;\r\n}\r\n\r\n::ng-deep .matoutlinestyles .mat-form-field-label-wrapper {\r\n  top: -0.84375em !important;\r\n}\r\n\r\n// Card status border colors\r\n.active_card {\r\n  border-left: 4px solid #07a36e;\r\n}\r\n.progress_card {\r\n  border-left: 4px solid #ffc107;\r\n}\r\n.failed_card {\r\n  border-left: 4px solid #da606c;\r\n}\r\n.primary_card {\r\n  border-left: 4px solid #007bff;\r\n}\r\n.ignored_card{\r\n  border-left: 4px solid #808080b0;\r\n}\r\n.inprogress_card{\r\n  border-left: 4px solid #ff8900;\r\n}\r\n.border-gradient {\r\n  border-left: 4px solid !important;\r\n  border-image-slice: 1;\r\n  border-block: 0;\r\n  border-right: 0;\r\n}\r\n.border-gradient-redgreen {\r\n  border-image-source: linear-gradient(to bottom, #db6c6c, #22ed86);\r\n}\r\n\r\n// Add pointer cursor to radio buttons - Scoped to this component only\r\n::ng-deep .compare-pinned-component {\r\n  .radio-button-group {\r\n    cursor: pointer !important;\r\n    \r\n    mat-radio-button {\r\n      cursor: pointer !important;\r\n      pointer-events: auto !important;\r\n      \r\n      * {\r\n        cursor: pointer !important;\r\n        pointer-events: auto !important;\r\n      }\r\n      \r\n      .mdc-form-field {\r\n        cursor: pointer !important;\r\n        pointer-events: auto !important;\r\n        \r\n        * {\r\n          cursor: pointer !important;\r\n          pointer-events: auto !important;\r\n        }\r\n        \r\n        .mdc-form-field__label {\r\n          cursor: pointer !important;\r\n          pointer-events: auto !important;\r\n        }\r\n        \r\n        .mdc-radio {\r\n          cursor: pointer !important;\r\n          pointer-events: auto !important;\r\n          bottom: 3px;\r\n          \r\n          * {\r\n            cursor: pointer !important;\r\n            pointer-events: auto !important;\r\n          }\r\n          \r\n          .mdc-radio__native-control {\r\n            cursor: pointer !important;\r\n            pointer-events: auto !important;\r\n          }\r\n        }\r\n      }\r\n      \r\n      label {\r\n        cursor: pointer !important;\r\n        pointer-events: auto !important;\r\n      }\r\n      \r\n      .mat-mdc-radio-button {\r\n        cursor: pointer !important;\r\n        pointer-events: auto !important;\r\n      }\r\n      \r\n      input[type=\"radio\"] {\r\n        cursor: pointer !important;\r\n      }\r\n    }\r\n  }\r\n  \r\n  // Additional scoped style for radio buttons in this component only\r\n  mat-radio-group.radio-button-group mat-radio-button,\r\n  mat-radio-group.radio-button-group mat-radio-button * {\r\n    cursor: pointer !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
